import React, { Fragment, useState, useRef, useEffect } from "react";
import FavoriteItem from "./FavoriteItem";
import Modal from "react-modal";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import { ramactions } from "../store/index";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import useCustomloadapi from "../hooks/use-scriptload";
import Tooltip from "./Tooltip";
import { useTranslation } from "react-i18next";
const Favorite = () => {
  const { t } = useTranslation("translation", { keyPrefix: "favorite" });
  const history = useHistory();
  window.scrollTo(0, 0);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isshowbutton, setIsshowbutton] = useState(true);
  const [message, setMessage] = useState("");
  const [invalidcaptcha, setInvalidcaptcha] = useState("");
  const [emaillists, setEmaillists] = useState("");
  const dispatch = useDispatch();
  const favoritearray = useSelector((index) => index.favoritearray);
  const etlidarray = favoritearray;
  const place = useSelector((index) => index.place);
  const searchBy = useSelector((index) => index.searchBy);
  const categoryId = useSelector((index) => index.categoryId);
  const subCategoryId = useSelector((index) => index.subCategoryId);
  const keyword = useSelector((index) => index.keyword);
  const [locationKeys, setLocationKeys] = useState([]);
  const ismaploaded = useCustomloadapi();
  let newstr = "[";
  let i = 1;
  if (etlidarray != undefined && etlidarray.length > 0) {
    etlidarray.map((index) => {
      if (i === 1) newstr += '"' + index + '"';
      else newstr += ',"' + index + '"';

      i = 2;
    });
    newstr += "]";
  }

  const recaptchaRef = useRef();

  const modalopenfn = async () => {
    setMessage("");
    setIsOpen(true);
  };

  const afterOpenModal = () => {
    // references are now sync'd and can be accessed.
    //subtitle.style.color = "#f00";
  };

  const closeModal = () => {
    setIsOpen(false);
    //Router.push("/");
  };

  const removeAll = () => {
    const updatedfavoritearray = [];
    //dispatch({ type: "addfavorite", favoritearray: updatedfavoritearray });
    dispatch(ramactions.addfavorite(updatedfavoritearray));
    setIsshowbutton(false);
  };

  const sendemail = async () => {    
    if (emaillists.length > 0) {
      setMessage("");
      if (recaptchaRef.current.getValue().length === 0) {
        setInvalidcaptcha(t("invalid_captcha"));
      } else {
        setInvalidcaptcha("");
        const response = await axios.post(
          "/wp-admin/admin-ajax.php?action=callback_send_email_ram2",
          {
            email: emaillists,
            rid: JSON.stringify(favoritearray.toString()),
          }
        );
        //console.log(response);
        if (response.data === "success") setMessage(t("email_sent"));
        else setMessage(t("error"));
        setEmaillists("");
      }
    } else setMessage(t("enter_emails"));
  };

  const emaillistshanddler = (e) => {
    setEmaillists(e.target.value);
  };

  useEffect(() => {
    return history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
      }

      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);

          // Handle forward event
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);

          // Handle back event
          //console.log("Back clicked!!");
          backTosearch();
        }
      }
    });
  }, [locationKeys]);

  const backTosearch = () => {
    if (place.formatted_address.length > 0) {
      let $restUrl;
      if (searchBy === "topic") {
        $restUrl = "&category=" + categoryId + "&subcategory=" + subCategoryId;
      } else {
        $restUrl = "&keyword=" + keyword;
      }
      /*console.log(
        "?location=" + place.formatted_address + "&type=" + searchBy + $restUrl
      );*/
      history.push({
        search:
          "?location=" +
          place.formatted_address +
          "&type=" +
          searchBy +
          $restUrl,
      });
    }
    dispatch(ramactions.changestatus(0));
    dispatch(ramactions.updateApiCall(false));
    window.scrollTo(0, 0);
  };
  const isFavRemoved = useSelector((state) => state.isFavoriteRemoved);

  return (
    <div className="ram-favourites">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="fav-intro">
              <div className="text-center">
                <Link
                  className="pull-left back-btn back-to-search-result"
                  aria-label={t("back")}
                  role="button"
                  onClick={backTosearch}
                >
                  <span className="btb bt-arrow-left"></span>
                </Link>

                <h2 className="header-one d-inline" tabindex="0">
                  {t("page_title")}
                </h2>
                <span className="fav-wrapper pull-right">
                  {isFavRemoved && (
                    <Tooltip
                      tipText={t("removed_from_favorites_tooltip")}
                    ></Tooltip>
                  )}
                  <span className="bts bt-star" aria-hidden="true"></span>
                  <span className="sr-only">{t("favourites")}</span>
                  <span className="step step-favourites" aria-hidden="true">
                    {favoritearray.length}
                  </span>
                </span>
              </div>
              <p>{t("page_description")}</p>
              {favoritearray.length > 0 && (
                <div className="text-center email-pdf-btn">
                  <button
                    type="button"
                    onClick={modalopenfn}
                    className="btn btn-primary send-email"
                  >
                    <span className="btb bt-envelope" aria-hidden="true"></span>{" "}
                    {t("email_list")}
                  </button>
                  <a
                    href={"/?file=pdf&id=" + window.btoa(newstr)}
                    role="button"
                    className="btn btn-primary get-pdf"
                    target="_blank"
                    download=""
                    rel="noreferrer"
                  >
                    <span className="btb bt-download" aria-hidden="true"></span>{" "}
                    {t("get_pdf")}
                  </a>
                </div>
              )}
            </div>
            {/* <h1>This is Favorite Section. </h1> */}
            {/* {favoritearray.length > 0 && (
              <div>
                <a
                  href={"/?file=pdf&id=" + window.btoa(newstr)}
                  role="button"
                  className="btn btn-primary get-pdf"
                >
                  <span
                    className="btb bt-download"
                    aria-hidden="true"
                    download
                  ></span>{" "}
                  Get PDF
                </a>
                <button
                  type="button"
                  className="btn btn-primary send-email"
                  onClick={modalopenfn}
                >
                  <span className="btb bt-envelope" aria-hidden="true"></span>{" "}
                  Email list
                </button>
              </div>
            )} */}
            {etlidarray !== undefined && (
              <div className="accordion-wrapper">
                {etlidarray.map((item) => (
                  <FavoriteItem key={item} etlloadid={item} />
                ))}
              </div>
            )}
            {favoritearray.length > 0 && (
              <div className="btn-wrapper text-center clear-list-btn">
                <button
                  type="button"
                  className="btn btn-primary clear-favourites"
                  onClick={removeAll}
                >
                  <span className="btb bt-ban" aria-hidden="true"></span>{" "}
                  {t("clear_list")}
                </button>

                <div className="back-search-link">
                  <Link
                    role="button"
                    className="back-to-search-result"
                    onClick={backTosearch}
                  >
                    <span
                      className="btb bt-arrow-left"
                      aria-hidden="true"
                    ></span>
                    {t("back_to_results")}
                  </Link>
                </div>
              </div>
            )}
            {/* {favoritearray.length > 0 && (
              <button onClick={removeAll}>Remove all</button>
            )} */}
            {favoritearray.length === 0 && <p>{t("no_result")}</p>}
            <Modal
              isOpen={modalIsOpen}
              onAfterOpen={afterOpenModal}
              onRequestClose={closeModal}
              contentLabel="Modal"
              className="ram ram-modal"
            >
              <div className="modal-content">
                <div class="modal-header">
                  <div class="icon">
                    <span class="btb bt-envelope" aria-hidden="true"></span>
                  </div>
                  <div class="title">
                    <h2>{t("modal_title")}</h2>
                  </div>
                  <button
                    type="button"
                    id="dismiss-mail-pop"
                    class="close"
                    data-dismiss="modal"
                    aria-label={t("close")}
                    onClick={closeModal}
                  >
                    <span class="btb bt-times" aria-hidden="true"></span>
                  </button>
                </div>
                <div className="modal-body">
                  <p>{t("modal_description")}</p>
                  <div className="form-wrap">
                    <input type="hidden" name="send_mail" value="send_mail" />
                    <input
                      type="hidden"
                      name="resources_id"
                      className="resources_id"
                      value=""
                    />
                    <label for="emailAddress" className="sr-only">
                      {t("modal_input_label")}
                    </label>
                    <input
                      type="email"
                      className="form-control default-input email-address"
                      id="emailAddress"
                      placeholder={t("modal_email_input_placeholder")}
                      value={emaillists}
                      onChange={emaillistshanddler}
                    />
                    {message.length > 0 && (
                      <span className="error" role="alert">
                        {message}
                      </span>
                    )}
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={process.env.REACT_APP_GET_RECAPTCHA_KEY}
                      className="recaptcha"
                    />
                    {invalidcaptcha.length > 0 && (
                      <span className="error" role="alert">
                        {invalidcaptcha}
                      </span>
                    )}
                    <button
                      className="btn btn-poup send-favourites-email"
                      onClick={sendemail}
                    >
                      <span
                        className="btb bt-envelope"
                        aria-hidden="true"
                      ></span>{" "}
                      {t("send_email")}
                    </button>
                  </div>
                  {/* <button onClick={closeModal} className="close">
                    <span class="btb bt-times" aria-hidden="true"></span>
                  </button> */}
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Favorite;
